import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "contract_modal",
  "use": "contract_modal-usage",
  "viewBox": "0 0 120 120",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 120 120\" id=\"contract_modal\">\r\n<image style=\"overflow:visible;\" width=\"2522\" height=\"3000\" xlink:href=\"17224828784356ac3faccf2d4d975539.png\" transform=\"matrix(4.016991e-02 0 0 4.016991e-02 9.4681 -0.1649)\">\r\n</image>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol